import { Input, Typography } from 'antd';
import React from 'react';

interface CustomInputProps {
  id?: string;
  showInput: boolean;
  disabled?: boolean;
  placeholder?: string;
  value?: any;
  maxLength?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  style?: React.CSSProperties;
}

const CustomInput: React.FC<CustomInputProps> = ({
  id,
  showInput,
  disabled = false,
  placeholder = 'Please provide a value.',
  value,
  maxLength = 200,
  onChange,
  style,
}) => {
  const { Text } = Typography;
  return (
    <>
      {showInput && (
        <Input
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
          disabled={disabled}
        ></Input>
      )}
      {!showInput && <Text style={style}>{value}</Text>}
    </>
  );
};

export default CustomInput;